export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'search'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
            },
            {
                name: "user.username",
                label: "Felhasználónév",
                filter: {
                    type: "simple",
                },
                sort: false,
                visibility: true
            },
            {
                name: "time",
                label: "Bejelentkezési idő",
                filter: {
                    type: "simple",
                },
                sort: true,
                slot_name: "datetime_format",
            },
            {
                name: "ip",
                label: "IP cím",
                filter: {
                    type: "simple",
                },
                sort: false,
                formType: 'text'
            },
            {
                name: "os",
                label: "Operációs rendszer",
                filter: {
                    type: "simple",
                },
                sort: false,
            },
            {
                name: "browser",
                label: "Böngésző",
                filter: {
                    type: "simple",
                },
                sort: false,
            },
            {
                name: "browserVersion",
                label: "Böngésző verzió",
                filter: {
                    type: "simple",
                },
                sort: false,
            },
            {
                name: "browserPlugins",
                label: "Bőngésző plugins",
                visibility: false,
            },
            {
                name: "resolution",
                label: "Resolution",
                visibility: false,
            }
        ]
    }
}
